import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AchievementBadges = () => {
  const [selectedBadge, setSelectedBadge] = useState(null);

  const achievements = [
    {
      id: 1,
      title: "Primer Rescate",
      description: "Completaste tu primera bolsa sorpresa",
      icon: "Award",
      color: "var(--color-warning)",
      earned: true,
      earnedDate: "2024-09-15",
      progress: 100,
      requirement: "Rescatar 1 bolsa sorpresa"
    },
    {
      id: 2,
      title: "Eco Guerrero",
      description: "Rescataste 10 kg de comida",
      icon: "Leaf",
      color: "var(--color-success)",
      earned: true,
      earnedDate: "2024-10-02",
      progress: 100,
      requirement: "Rescatar 10 kg de comida"
    },
    {
      id: 3,
      title: "Racha de Fuego",
      description: "7 días consecutivos rescatando",
      icon: "Flame",
      color: "var(--color-accent)",
      earned: true,
      earnedDate: "2024-10-20",
      progress: 100,
      requirement: "Rescatar durante 7 días consecutivos"
    },
    {
      id: 4,
      title: "Guardián del Agua",
      description: "Ahorraste 500L de agua",
      icon: "Droplets",
      color: "var(--color-primary)",
      earned: true,
      earnedDate: "2024-11-01",
      progress: 100,
      requirement: "Ahorrar 500L de agua"
    },
    {
      id: 5,
      title: "Campeón del Campus",
      description: "Top 10 en tu universidad",
      icon: "Trophy",
      color: "var(--color-warning)",
      earned: false,
      progress: 75,
      requirement: "Estar en el top 10 de tu universidad",
      currentValue: "Posición #12"
    },
    {
      id: 6,
      title: "Maestro del Rescate",
      description: "Rescata 50 kg de comida",
      icon: "Crown",
      color: "var(--color-secondary)",
      earned: false,
      progress: 68,
      requirement: "Rescatar 50 kg de comida",
      currentValue: "34 kg rescatados"
    }
  ];

  const handleShare = (badge) => {
    if (navigator.share) {
      navigator.share({
        title: `¡Conseguí el logro "${badge?.title}" en FoodRescue!`,
        text: `${badge?.description} - Únete a mí en la lucha contra el desperdicio de alimentos.`,
        url: window.location?.origin
      });
    } else {
      // Fallback for browsers that don't support Web Share API
      const text = `¡Conseguí el logro "${badge?.title}" en FoodRescue! ${badge?.description}`;
      navigator.clipboard?.writeText(text);
      alert('Texto copiado al portapapeles');
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="font-heading font-semibold text-lg text-foreground">
          Logros y Reconocimientos
        </h3>
        <div className="text-sm text-muted-foreground">
          {achievements?.filter(a => a?.earned)?.length} de {achievements?.length} conseguidos
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
        {achievements?.map((achievement) => (
          <div
            key={achievement?.id}
            className={`relative p-4 rounded-lg border-2 cursor-pointer transition-all ${
              achievement?.earned 
                ? 'border-success bg-success/5 hover:bg-success/10' :'border-border bg-muted/30 hover:bg-muted/50'
            }`}
            onClick={() => setSelectedBadge(achievement)}
          >
            <div className="text-center">
              <div className={`w-12 h-12 mx-auto mb-2 rounded-full flex items-center justify-center ${
                achievement?.earned ? 'bg-success/20' : 'bg-muted'
              }`}>
                <Icon 
                  name={achievement?.icon} 
                  size={24} 
                  color={achievement?.earned ? achievement?.color : 'var(--color-muted-foreground)'} 
                />
              </div>
              <h4 className={`text-xs font-medium ${
                achievement?.earned ? 'text-foreground' : 'text-muted-foreground'
              }`}>
                {achievement?.title}
              </h4>
              
              {!achievement?.earned && (
                <div className="mt-2">
                  <div className="w-full bg-muted rounded-full h-1.5">
                    <div 
                      className="bg-primary h-1.5 rounded-full transition-all"
                      style={{ width: `${achievement?.progress}%` }}
                    ></div>
                  </div>
                  <span className="text-xs text-muted-foreground mt-1 block">
                    {achievement?.progress}%
                  </span>
                </div>
              )}
            </div>

            {achievement?.earned && (
              <div className="absolute -top-1 -right-1 w-5 h-5 bg-success rounded-full flex items-center justify-center">
                <Icon name="Check" size={12} color="white" />
              </div>
            )}
          </div>
        ))}
      </div>
      {/* Achievement Details Modal */}
      {selectedBadge && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4">
          <div className="bg-background rounded-lg p-6 w-full max-w-md">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-heading font-semibold text-lg text-foreground">
                Detalle del Logro
              </h3>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => setSelectedBadge(null)}
              >
                <Icon name="X" size={20} />
              </Button>
            </div>

            <div className="text-center mb-6">
              <div className={`w-20 h-20 mx-auto mb-4 rounded-full flex items-center justify-center ${
                selectedBadge?.earned ? 'bg-success/20' : 'bg-muted'
              }`}>
                <Icon 
                  name={selectedBadge?.icon} 
                  size={40} 
                  color={selectedBadge?.earned ? selectedBadge?.color : 'var(--color-muted-foreground)'} 
                />
              </div>
              
              <h4 className="font-heading font-semibold text-xl text-foreground mb-2">
                {selectedBadge?.title}
              </h4>
              
              <p className="text-muted-foreground mb-4">
                {selectedBadge?.description}
              </p>

              <div className="bg-muted rounded-lg p-4 text-left">
                <h5 className="font-medium text-foreground mb-2">Requisito:</h5>
                <p className="text-sm text-muted-foreground mb-3">
                  {selectedBadge?.requirement}
                </p>

                {selectedBadge?.earned ? (
                  <div className="flex items-center space-x-2 text-success">
                    <Icon name="CheckCircle" size={16} />
                    <span className="text-sm font-medium">
                      Conseguido el {new Date(selectedBadge.earnedDate)?.toLocaleDateString('es-ES')}
                    </span>
                  </div>
                ) : (
                  <div>
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-sm text-muted-foreground">Progreso</span>
                      <span className="text-sm font-medium text-foreground">
                        {selectedBadge?.progress}%
                      </span>
                    </div>
                    <div className="w-full bg-border rounded-full h-2 mb-2">
                      <div 
                        className="bg-primary h-2 rounded-full transition-all"
                        style={{ width: `${selectedBadge?.progress}%` }}
                      ></div>
                    </div>
                    {selectedBadge?.currentValue && (
                      <p className="text-xs text-muted-foreground">
                        Estado actual: {selectedBadge?.currentValue}
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="flex space-x-3">
              {selectedBadge?.earned && (
                <Button
                  variant="outline"
                  className="flex-1"
                  onClick={() => handleShare(selectedBadge)}
                >
                  <Icon name="Share2" size={16} className="mr-2" />
                  Compartir
                </Button>
              )}
              
              <Button
                variant="default"
                className="flex-1"
                onClick={() => setSelectedBadge(null)}
              >
                Cerrar
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AchievementBadges;